import { createAction } from 'redux-act';
//////////////////////////////////////////////////

export const toggleCompact = createAction('analyticsToggleCompact');
export const setFilters = createAction('analyticsSetFilters');
export const setPageOptions = createAction('analyticsSetPageOptions');

export const getAnalyticsRegionsRequest = createAction('getAnalyticsRegionsRequest');
export const exportAnalyticsReportRequest = createAction('exportAnalyticsReportRequest');
export const getAnalyticsSyncStatusRequest = createAction('getAnalyticsSyncStatusRequest');
export const getListFleetDriversDownRequest = createAction('analyticsGetFleetDriversRequest');
export const getAnalyticsWeeklyRpmByRegionReportRequest = createAction('getAnalyticsWeeklyRpmByRegionReportRequest');
export const getAnalyticsWeeklyRpmByRegionReportOrdersRequest =
  createAction('getAnalyticsWeeklyRpmByRegionReportOrdersRequest');
export const getAnalyticsFleetActivityReportRequest = createAction('getAnalyticsFleetActivityReportRequest');
export const getAnalyticsFleetActivityReportTelsRequest = createAction('getAnalyticsFleetActivityReportTelsRequest');
export const getAnalyticsLaneRpmReportRequest = createAction('getAnalyticsLaneRpmReportRequest');
export const getAnalyticsLaneRpmReportLanesRequest = createAction('getAnalyticsLaneRpmReportLanesRequest');
export const getAnalyticsLaneRpmReportLaneOrdersRequest = createAction('getAnalyticsLaneRpmReportLaneOrdersRequest');
export const getAnalyticsLaneRpmReportLaneCustomersRequest =
  createAction('getAnalyticsLaneRpmReportLaneCustomersRequest');

export const setExpanded = createAction('analyticsSetExpanded');
export const getAnalyticsWeeklyRpmByRegionReportLoading = createAction('getAnalyticsWeeklyRpmByRegionReportLoading');
export const getAnalyticsWeeklyRpmByRegionReportSuccess = createAction('getAnalyticsWeeklyRpmByRegionReportSuccess');
export const getAnalyticsWeeklyRpmByRegionReportFailure = createAction('getAnalyticsWeeklyRpmByRegionReportFailure');
export const getAnalyticsWeeklyRpmByRegionReportOrdersLoading =
  createAction('getAnalyticsWeeklyRpmByRegionReportOrdersLoading');
export const getAnalyticsWeeklyRpmByRegionReportOrdersSuccess =
  createAction('getAnalyticsWeeklyRpmByRegionReportOrdersSuccess');
export const getAnalyticsWeeklyRpmByRegionReportOrdersFailure =
  createAction('getAnalyticsWeeklyRpmByRegionReportOrdersFailure');
export const getAnalyticsFleetActivityReportLoading = createAction('getAnalyticsFleetActivityReportLoading');
export const getAnalyticsFleetActivityReportSuccess = createAction('getAnalyticsFleetActivityReportSuccess');
export const getAnalyticsFleetActivityReportFailure = createAction('getAnalyticsFleetActivityReportFailure');
export const getAnalyticsFleetActivityReportTelsLoading = createAction('getAnalyticsFleetActivityReportTelsLoading');
export const getAnalyticsFleetActivityReportTelsSuccess = createAction('getAnalyticsFleetActivityReportTelsSuccess');
export const getAnalyticsFleetActivityReportTelsFailure = createAction('getAnalyticsFleetActivityReportTelsFailure');
export const getAnalyticsLaneRpmReportLoading = createAction('getAnalyticsLaneRpmReportLoading');
export const getAnalyticsLaneRpmReportSuccess = createAction('getAnalyticsLaneRpmReportSuccess');
export const getAnalyticsLaneRpmReportFailure = createAction('getAnalyticsLaneRpmReportFailure');
export const getAnalyticsLaneRpmReportLanesLoading = createAction('getAnalyticsLaneRpmReportLanesLoading');
export const getAnalyticsLaneRpmReportLanesSuccess = createAction('getAnalyticsLaneRpmReportLanesSuccess');
export const getAnalyticsLaneRpmReportLanesFailure = createAction('getAnalyticsLaneRpmReportLanesFailure');
export const getAnalyticsLaneRpmReportLaneOrdersLoading = createAction('getAnalyticsLaneRpmReportLaneOrdersLoading');
export const getAnalyticsLaneRpmReportLaneOrdersSuccess = createAction('getAnalyticsLaneRpmReportLaneOrdersSuccess');
export const getAnalyticsLaneRpmReportLaneOrdersFailure = createAction('getAnalyticsLaneRpmReportLaneOrdersFailure');
export const getAnalyticsLaneRpmReportLaneCustomersLoading =
  createAction('getAnalyticsLaneRpmReportLaneCustomersLoading');
export const getAnalyticsLaneRpmReportLaneCustomersSuccess =
  createAction('getAnalyticsLaneRpmReportLaneCustomersSuccess');
export const getAnalyticsLaneRpmReportLaneCustomersFailure =
  createAction('getAnalyticsLaneRpmReportLaneCustomersFailure');
export const getAnalyticsRegionsLoading = createAction('getAnalyticsRegionsLoading');
export const getAnalyticsRegionsSuccess = createAction('getAnalyticsRegionsSuccess');
export const getAnalyticsRegionsFailure = createAction('getAnalyticsRegionsFailure');
export const getListFleetDriversDownLoading = createAction('getListFleetDriversDownLoading');
export const getListFleetDriversDownSuccess = createAction('getListFleetDriversDownSuccess');
export const getListFleetDriversDownFailure = createAction('getListFleetDriversDownFailure');
export const getAnalyticsSyncStatusLoading = createAction('getAnalyticsSyncStatusLoading');
export const getAnalyticsSyncStatusSuccess = createAction('getAnalyticsSyncStatusSuccess');
export const getAnalyticsSyncStatusFailure = createAction('getAnalyticsSyncStatusFailure');

export const setWeeklyRpmLoading = createAction('analyticsSetWeeklyRpmLoading');
export const setFleetActivityLoading = createAction('analyticsSetFleetActivityLoading');
export const setLaneRpmLoading = createAction('analyticsSetLaneRpmLoading');

export const setInitialState = createAction('analyticsSetInitialState');
